import { useState } from "react";
import { Mail } from "lucide-react";
import { Shell, Head, Field, Btn, Alert } from "../../components/ui/AuthComponents";
import { useAuth } from "../../hooks/useAuth";

export default function SuperAdminLogin({ onBack, onSuccess }) {
  const { loginSuperAdmin } = useAuth();

  const [f, setF] = useState({ email: "", pass: "" });
  const [e, setE] = useState({});
  const [loading, setLoading]   = useState(false);
  const [apiError, setApiError] = useState("");

  const upd = k => v => {
    setF(p => ({ ...p, [k]: v }));
    setE(p => ({ ...p, [k]: "" }));
    setApiError("");
  };

  const validate = () => {
    const err = {};
    if (!f.email.trim())                    err.email = "Email required";
    else if (!/\S+@\S+\.\S+/.test(f.email)) err.email = "Invalid email format";
    if (!f.pass)                            err.pass  = "Password required";
    return err;
  };

  const submit = async () => {
    const err = validate();
    if (Object.keys(err).length) { setE(err); return; }

    setLoading(true);
    setApiError("");

    const result = await loginSuperAdmin({
      email:    f.email,
      password: f.pass,
    });

    setLoading(false);

    if (result.error) {
      setApiError(result.error);
    } else {
      onSuccess("superadmin");
    }
  };

  const handleKeyDown = (e) => { if (e.key === "Enter") submit(); };

  return (
    <Shell role="superadmin" onBack={onBack}>
      <Head
        eyebrow="Super Admin"
        ec="#6a1b9a"
        title="System control panel"
        sub="Restricted — authorized personnel only"
      />
      <div style={{ display: "flex", flexDirection: "column", gap: 15 }}>

        <div className="fu d1">
          <Alert type="warn">
            This area is restricted to authorized administrators. All access attempts are logged and monitored.
          </Alert>
        </div>

        {apiError && (
          <div className="fu">
            <Alert type="warn">{apiError}</Alert>
          </div>
        )}

        <Field
          label="Admin Email"
          type="email"
          value={f.email}
          onChange={upd("email")}
          placeholder="admin@canluxa.com"
          icon={Mail}
          error={e.email}
          autoFocus
          delay="d2"
          onKeyDown={handleKeyDown}
        />
        <Field
          label="Password"
          type="password"
          value={f.pass}
          onChange={upd("pass")}
          placeholder="••••••••"
          error={e.pass}
          delay="d3"
          onKeyDown={handleKeyDown}
        />

        <div className="fu d4" style={{ marginTop: 4 }}>
          <Btn label="Sign In →" loading={loading} onClick={submit} />
        </div>
      </div>
    </Shell>
  );
}